import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconAddress = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M22.595 17.145c-2.644.557-4.712 2.783-5.088 5.46a6.6 6.6 0 0 0 .45 3.508c1.252 3.393 4.492 7.415 5.668 8.746.2.227.55.227.75 0 1.176-1.33 4.416-5.353 5.669-8.746a6.5 6.5 0 0 0 .516-2.583c-.016-4.061-3.762-7.27-7.965-6.385M24 26.658a3.084 3.084 0 1 1 0-6.17 3.084 3.084 0 0 1 0 6.17M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m13.808 36.149a2 2 0 0 1-2 2H12.192a2 2 0 0 1-2-2V17.312a2 2 0 0 1 .995-1.73l11.82-6.869a2 2 0 0 1 2.012.001l11.795 6.868a2 2 0 0 1 .994 1.728z',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconAddress)
export default ForwardRef
